"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUnknownError = exports.isServerError = exports.getErrorMessageIfAxiosError = exports.getErrorMessageByHTTPStatusCode = exports.getErrorMessageKey = void 0;
const axios_1 = __importDefault(require("axios"));
const error_types_1 = require("./error.types");
const error_enum_1 = require("./error.enum");
const getErrorMessageKey = (errMessage) => error_enum_1.ErrorMessagesEnum[errMessage.type];
exports.getErrorMessageKey = getErrorMessageKey;
const getErrorMessageByHTTPStatusCode = (statusCode) => {
    const result = error_types_1.HTTPStatusCodeToErrorMessageMap[statusCode];
    return result;
};
exports.getErrorMessageByHTTPStatusCode = getErrorMessageByHTTPStatusCode;
const getErrorMessageIfAxiosError = (e) => {
    if (e.response?.status) {
        return (0, exports.getErrorMessageByHTTPStatusCode)(e.response.status);
    }
};
exports.getErrorMessageIfAxiosError = getErrorMessageIfAxiosError;
const isServerError = (e) => {
    if (!e.response) {
        return false;
    }
    const status = e.response.status;
    return status >= 500;
};
exports.isServerError = isServerError;
const getUnknownError = (e) => {
    if (!(e instanceof Error)) {
        return { type: 'UNEXPECTED_ERROR' };
    }
    if (e instanceof TypeError) {
        return { type: 'UNEXPECTED_ERROR' };
    }
    if (!axios_1.default.isAxiosError(e)) {
        return { type: 'UNEXPECTED_ERROR' };
    }
    if (!e.response) {
        return { type: 'CONNECTION_FAILURE' };
    }
    const messageType = (0, exports.getErrorMessageIfAxiosError)(e);
    if (messageType) {
        return { type: messageType };
    }
    if ((0, exports.isServerError)(e)) {
        return { type: 'SYSTEM_FAILURE' };
    }
    return { type: 'UNEXPECTED_ERROR' };
};
exports.getUnknownError = getUnknownError;
